import React from 'react';
import { ClockIcon, LockIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { PRODUCT } from '../data/content';
import { useCountdown } from '../hooks/useCountdown';
export function FinalCta() {
  const time = useCountdown(14 * 3600 + 51 * 60 + 12);
  return <section className="radial-green py-10 text-center sm:py-12" style={{
    paddingTop: "24px",
    paddingBottom: "4px"
  }} data-id="element-74" data-mp="15d3z65b22omt">
      <div className="mx-auto max-w-content px-5" data-id="element-75" data-mp="1jbtwnm1seqbp">
        <p className="inline-flex items-center gap-2 rounded-full border border-lime-700/50 bg-ink-850 px-4 py-2 text-xs font-extrabold uppercase tracking-[0.2em] text-lime-400" data-id="element-76" data-mp="1eebmxtfy472n">
          <ClockIcon className="h-4 w-4" aria-hidden="true" data-id="element-77" data-mp="1t4rb9h3nrv51" />
          The price closes soon · {time}
        </p>

        <h2 className="mx-auto mt-4 max-w-3xl text-2xl font-extrabold leading-[1.08] tracking-tight text-white sm:text-4xl" data-id="element-78" data-mp="223mj0xmcpdag">
          Stop massaging the echo.
          <span className="block text-lime-400" data-id="element-79" data-mp="1x6cudk6sd5no">Fix the source.</span>
        </h2>

        <div className="mt-5 flex flex-col items-center" data-id="element-80" data-mp="n6w5wvtqbkam">
          <CtaButton label={`Get started now — ${PRODUCT.price}`} data-id="element-81" data-mp="s4fjrumilv21" />
          <p className="mt-3 text-sm font-semibold text-white/60" data-id="element-82" data-mp="s6s1q7s9w5f3">
            6 Volumes + 4 Bonuses · Instant PDF · One payment · Yours forever
          </p>
          <ul className="mt-2.5 flex flex-wrap items-center justify-center gap-x-4 gap-y-1.5 text-xs font-semibold text-white/45" data-id="element-83" data-mp="123wni6i7hyvd">
            <li className="inline-flex items-center gap-1.5" data-id="element-84" data-mp="1646vtpth11de">
              <LockIcon className="h-4 w-4 text-lime-400" aria-hidden="true" data-id="element-85" data-mp="1b2i3btwamzsg" />
              Secure payment
            </li>
            <li className="inline-flex items-center gap-1.5" data-id="element-86" data-mp="1fus11w3nh45a">
              <ZapIcon className="h-4 w-4 text-lime-400" aria-hidden="true" data-id="element-87" data-mp="1ktmiatlyykna" />
              2-minute access
            </li>
            <li className="inline-flex items-center gap-1.5" data-id="element-88" data-mp="1ptqysjmvnfdi">
              <ShieldCheckIcon className="h-4 w-4 text-lime-400" aria-hidden="true" data-id="element-89" data-mp="1ttrnqy7lr8yt" />
              7-day guarantee
            </li>
          </ul>
        </div>
      </div>
    </section>;
}